$(document).on('turbolinks:load', () => {
  // For an unknown reason, IE11 corrupts the stdDeviation value of this SVG filter upon Turbolinks
  // "back" navigation. Please keep this value in sync with one in partials/svg_blur partial.
  $('#svgBlurFilter feGaussianBlur').attr('stdDeviation', '70')
  $('#svgBlurFilterLight feGaussianBlur').attr('stdDeviation', '7')
})
